
export default class App {
    
    rootElement = null;

    setup() {
        this.rootElement = document.querySelector('#content');
    }

    menuOpened() {
        this.rootElement.classList.add('menu-opened');
    }

    menuClosed() {
        this.rootElement.classList.remove('menu-opened');
    }
}
